import { Box, Text } from "@chakra-ui/react";
import React from "react";

export const FooterHelp = () => {
  return (
    <Box mt="40px">
      <Text fontWeight={"400"} p="12px 16px" textAlign="left" fontSize="14px">
        &copy; 2022 Indeed - Cookies, Privacy and Terms - Employer Help Center
      </Text>
    </Box>
  );
};
